import { Injectable } from '@angular/core';
import { dispatch, select } from '@ngxs/store';
import {
    ClearGlobalSearch,
    ClearRecentSearchTerms,
    RememberSearchTerm,
    SearchGlobally
} from '@core/state/global-search/global-search.actions';
import { GlobalSearchState } from '@core/state/global-search/global-search.state';

/** The global search lives in the app shell, where no page exists to own its NGXS access. */
@Injectable({ providedIn: 'root' })
export class GlobalSearchStoreService {
    public readonly term = select(GlobalSearchState.term);
    public readonly sequences = select(GlobalSearchState.sequences);
    public readonly nuggets = select(GlobalSearchState.nuggets);
    public readonly isLoading = select(GlobalSearchState.isLoading);
    public readonly hasError = select(GlobalSearchState.hasError);
    public readonly resultCount = select(GlobalSearchState.resultCount);
    public readonly recentTerms = select(GlobalSearchState.recentTerms);

    public readonly search = dispatch(SearchGlobally);
    public readonly clear = dispatch(ClearGlobalSearch);
    public readonly rememberTerm = dispatch(RememberSearchTerm);
    public readonly clearRecentTerms = dispatch(ClearRecentSearchTerms);
}
